import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { ACTIVE_TAB } from '../utils/constants';

const DynamicNavigationTabs = ({
  children,
  step,
  nextStep,
  disabledConditional,
  callBackForActiveTabUpdate,
}) => {
  const [activeTab, setActiveTab] = useState(ACTIVE_TAB.ONE);

  useEffect(() => {
    setActiveTab(step);
  }, [step]);

  useEffect(() => {
    setActiveTab(ACTIVE_TAB.ONE);
  }, []);

  useEffect(() => {
    if (callBackForActiveTabUpdate) {
      callBackForActiveTabUpdate(activeTab);
    }
  }, [activeTab]);

  return (
    <div className="tabs tabs--justify tabs--bordered-bottom overflow-inherit w-100">
      <div className="tabs__wrap">
        <Nav tabs>
          {children.map((child, index) => (
            <NavItem key={String(index + Number(ACTIVE_TAB.ONE))}>
              <NavLink
                className={classnames({
                  active: activeTab === String(index + Number(ACTIVE_TAB.ONE)),
                })}
                onClick={() => {
                  if (nextStep) {
                    nextStep(String(index + Number(ACTIVE_TAB.ONE)));
                  } else {
                    setActiveTab(String(index + Number(ACTIVE_TAB.ONE)));
                  }
                }}
                disabled={disabledConditional}
              >
                {child.props.title}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={activeTab}>
            {children[Number(activeTab - ACTIVE_TAB.ONE)]}
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

DynamicNavigationTabs.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  nextStep: PropTypes.func,
  step: PropTypes.string,
  disabledConditional: PropTypes.bool,
  callBackForActiveTabUpdate: PropTypes.func,
};

DynamicNavigationTabs.defaultProps = {
  nextStep: null,
  step: null,
  disabledConditional: false,
  callBackForActiveTabUpdate: null,
};

export default withTranslation('common')(DynamicNavigationTabs);
